import { render, staticRenderFns } from "./ContactDataChips.vue?vue&type=template&id=45a96189&scoped=true&"
import script from "./ContactDataChips.vue?vue&type=script&lang=js&"
export * from "./ContactDataChips.vue?vue&type=script&lang=js&"
import style0 from "./ContactDataChips.vue?vue&type=style&index=0&id=45a96189&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a96189",
  null
  
)

export default component.exports